import apiPaymentGateway from '../config/api_payment_gateway'

export function getTokenCreditCard(values) {
    var base = Buffer.from(`${process.env.REACT_APP_PAYMENT_GATEWAY_PUBLIC_KEY}:`).toString('base64');
    return apiPaymentGateway.post('', values, {
        headers: {
            'Authorization': `Basic ${base}`
        }
    });
}